import { Vector2 } from 'three';

export const COPY_PASTE_OFFSET_DEFAULT = new Vector2(1, -1);
